import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, shareReplay, startWith, switchMap } from 'rxjs/operators';
import { ProductService } from '../core/product.service';
import { productIds } from '../../globals';
import { CrmMultilocationInjectionToken } from './providers';

@Injectable({ providedIn: 'root' })
export class CrmSkuAccessService {
  private readonly productService = inject(ProductService);
  private readonly multiLocationConfig = inject(CrmMultilocationInjectionToken, { optional: true });

  readonly enableCustomObjects$: Observable<boolean> = (this.multiLocationConfig?.isMultiLocation$ ?? of(false)).pipe(
    startWith(false),
    switchMap((isMultiLocation) => {
      // In multi-location, disable custom objects immediately
      if (isMultiLocation) {
        return of(false);
      }

      // Single location: check activeProducts$ for CRM AI SKU
      return this.productService.activeProducts$.pipe(
        map((products) => products.some((product) => product.productId === productIds.crmAi)),
      );
    }),
    shareReplay({ refCount: true, bufferSize: 1 }),
  );
}
